//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
	name: 'FormField',

	props: {
		label: {
			type: String
		},

		element: {
			type: String,
			required: true
		},

		required: {
			type: Boolean,
			default: false
		},

		invalid: {
			type: [Boolean, Array],
			default: false
		},

		type: {
			type: String,
			default: 'text'
		},

		name: {
			type: String,
			default: ''
		},

		options: {
			type: [Boolean, Array],
			default: false
		},

		value: {
			default: ''
		},

		clear: {
			default: false
		}
	},

	data: function data() {
		return {
			isEmpty: true
		};
	},


	methods: {
		setEmpty: function setEmpty() {
			this.$refs.element.value = '';
			this.isEmpty = true;
		},
		onInput: function onInput() {
			var val = this.$refs.element.value;
			this.$emit('input', val);
		},
		onBlur: function onBlur() {
			this.isEmpty = this.$refs.element.value ? false : true;
		}
	},

	watch: {
		clear: function clear(val) {
			if (val) this.setEmpty();
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/FormField.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/FormField.vue
// module chunks = 0 1 2